/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-popup-notifications .swiper-pagination{text-align:left}app-popup-notifications .swiper-pagination.swiper-pagination-bullets{top:-5px;text-align:right}"];
export { styles as styles };
